/**
 * IWHC Gift Card — variant selection + AJAX add-to-cart
 */
(function() {
  'use strict';

  function init() {
    var container = document.querySelector('[data-gift-card-variants]');
    if (!container) return;

    var buttons = container.querySelectorAll('.gift-amount');
    var hiddenInput = document.getElementById('gift-card-variant-id');
    var form = document.getElementById('gift-card-form');

    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        buttons.forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        if (hiddenInput && btn.dataset.variantId) {
          hiddenInput.value = btn.dataset.variantId;
        }
      });
    });

    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var submitBtn = form.querySelector('[data-gift-add-to-cart]');
        var originalText = submitBtn.textContent;
        submitBtn.textContent = 'Adding...';
        submitBtn.disabled = true;

        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var body = new FormData();
        body.append('id', hiddenInput.value);
        body.append('quantity', '1');
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.append('sections', cart.getSectionsToRender().map(function(s) { return s.id; }).join(','));
          body.append('sections_url', window.location.pathname);
        }

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: body
        })
        .then(function(response) { return response.json(); })
        .then(function(response) {
          if (response.status && response.status !== 200) {
            submitBtn.textContent = 'Error';
            setTimeout(function() { submitBtn.textContent = originalText; submitBtn.disabled = false; }, 1500);
            return;
          }
          submitBtn.textContent = 'Added!';
          setTimeout(function() {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 1500);
          try {
            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(response);
            }
          } catch(err) {}
          window.iwhcRefreshCartBubble();
        })
        .catch(function(err) {
          console.error('Gift card add error:', err);
          submitBtn.textContent = 'Added!';
          setTimeout(function() { submitBtn.textContent = originalText; submitBtn.disabled = false; }, 1500);
          window.iwhcRefreshCartBubble();
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
